import { DataGrid, gridClasses, GridColDef } from '@mui/x-data-grid';

import { RootState } from '../../../../../../reducers';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../store/store';
import { clearSelections, getFuhFumAlerts, getTopThreeMatches, setRowSelectionModel, setUnmatchedId } from '../../../../../../store/hie.slice';
import { isValid } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';
import { isDefaultDate } from '../../../../../../utils/common';
import { useEffect, useState } from 'react';
import { toDate } from '../../../../../../utils/dateHelpers';
import { GridRowSelectionModel } from '@mui/x-data-grid';

const FuhFumOpenAlerts = () => {
    const dispatch = useAppDispatch();

    const { fuhfumAlerts, showArchivedAlerts, unmatchedId } = useSelector((state: RootState) => state.hie);
    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 10 });
    const [alertsRowSelectionModel, setAlertsRowSelectionModel] = useState<GridRowSelectionModel>({
        type: 'include', // or 'exclude'
        ids: new Set([]), // Your initial row IDs
    });

    const columns: GridColDef[] = [
        {
            field: 'LastName',
            headerName: 'Last Name',
            minWidth: 160,
        },
        {
            field: 'FirstName',
            headerName: 'First Name',
            minWidth: 160,
        },
        {
            field: 'DOB',
            headerName: 'DOB',
            minWidth: 160,
            flex: 1,
            valueGetter: (value, row) => {
                const d = toDate(row.DOB);
                return `${!isValid(d) || !row.DOB || isDefaultDate(row.DOB) ? 'N/A' : formatInTimeZone(d, 'UTC', 'MM/dd/yyyy')}`;
            },
        },
        {
            field: 'MemberAHCCCS',
            headerName: 'AHCCCS ID',
            flex: 1,
        },
        {
            field: 'SendingFacility',
            headerName: 'Sending Facility',
            minWidth: 270,
            flex: 1.5,
        },
        {
            field: 'VisitType',
            headerName: 'Visit Type',
            minWidth: 200,
            flex: 1,
        },
        {
            field: 'AdmitDate',
            headerName: 'Admission Date',
            minWidth: 160,
            valueGetter: (value, row) => {
                const d = toDate(row.AdmitDate);
                return `${!isValid(d) || !row.AdmitDate || isDefaultDate(row.AdmitDate) ? 'N/A' : formatInTimeZone(d, 'UTC', 'MM/dd/yyyy')}`;
            },
        },
        {
            field: 'DischargeDate',
            headerName: 'Discharge Date',
            minWidth: 160,
            valueGetter: (value, row) => {
                const d = toDate(row.DischargeDate);
                return `${!isValid(d) || !row.DischargeDate || isDefaultDate(row.DischargeDate) ? 'N/A' : formatInTimeZone(d, 'UTC', 'MM/dd/yyyy')}`;
            },
        },
    ];

    useEffect(() => {
        dispatch(getFuhFumAlerts());
    }, [dispatch]);

    return (
        <>
            <DataGrid
                onRowClick={(params: any) => {
                    const { DOB, Id, Patient } = params.row;
                    const names = Patient.split(' ');
                    dispatch(clearSelections());
                    dispatch(setUnmatchedId(Id));
                    dispatch(getTopThreeMatches(names[0], names[names.length - 1], DOB));
                }}
                autoHeight
                rows={showArchivedAlerts ? fuhfumAlerts : fuhfumAlerts.filter((alert) => alert.Archived !== true)}
                columns={columns}
                checkboxSelection={unmatchedId.length > 0 ? true : false}
                disableRowSelectionExcludeModel
                onRowSelectionModelChange={(newSelectionModel) => {
                    setAlertsRowSelectionModel(newSelectionModel);
                    const rowIds = Array.from(newSelectionModel.ids) || [];
                    dispatch(setRowSelectionModel(rowIds));
                }}
                rowSelectionModel={alertsRowSelectionModel}
                paginationModel={paginationModel}
                onPaginationModelChange={setPaginationModel}
                getRowId={(row) => row.Id}
                getRowHeight={() => 'auto'}
                getRowClassName={(params) => (params.row.Archived ? 'archived' : '')}
                sx={{
                    [`& .${gridClasses.cell}`]: {
                        py: 1,
                    },
                    [`& .archived`]: {
                        background: 'rgba(200,200,200,0.4)',
                        fontStyle: 'italic',
                    },
                }}
            />
        </>
    );
};

export default FuhFumOpenAlerts;
